export default {"src":"/_next/static/media/logo.3262c5bb.svg","height":60,"width":214};